<template>
  <b-card class="card-statistics">
    <b-media no-body>
      <b-media-aside class="mr-2">
        <b-avatar size="48" variant="light-secondary">
          <feather-icon size="24" icon="PersonIcon"/>
        </b-avatar>
      </b-media-aside>
      <b-media-body class="my-auto">
        <b-spinner v-if="loading" small class="align-middle"></b-spinner>
        <h4 v-else class="font-weight-bolder mb-0">
          {{ value }}
        </h4>
        <b-card-text class="font-small-3 mb-0">
          Students
        </b-card-text>
      </b-media-body>
    </b-media>
  </b-card>
</template>

<script>
export default {
  name: 'StatCard',
  props: {
    user: {
      type: Object,
      required: true
    },
    festivals: {
      type: Array,
      required: true
    },
    selections: {
      type: Array,
      required: true
    },
    applications: {
      type: Array,
      required: true
    },
    students: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
  },
  computed: {
    value() {
      if(this.user.groups.includes('Teacher')) {
        return this.students?.length || 0
      }
      if(this.user.groups.includes('NYSSMA_Committee') || this.user.groups.includes('NYSSMA_Chair')) {
        const selections = this.selections.filter(selection => this.user.ensembleIds.includes(selection.selectionEnsembleId) )
        const applications = this.applications.filter(application => selections.some(selection => application.applicationSelectionId === selection.id))
        const uniqueAppStudents = [...new Set(applications.map(item => item.studentApplicationsId))];
        return this.students?.filter(student => uniqueAppStudents.includes(student.id)).length || 0
      }
      if(this.user.groups.includes('ZoneRep')) {
        const festivalIds = [...new Set(this.festivals?.filter(festival => this.user.zoneIds.includes(festival.festivalZoneId)).map(festival => festival.id))];
        const applications = this.applications?.filter(app => festivalIds.includes(app.applicationFestivalId))
        const uniqueAppStudents = [...new Set(applications.map(item => item.studentApplicationsId))];
        return this.students?.filter(student => uniqueAppStudents.includes(student.id)).length || 0
      }
      return this.students?.length || 0
    },
    maxValue() {
      return this.students?.length || 0
    }
  }
}
</script>

<style scoped>

</style>
